export default __webpack_public_path__ + "static/media/gournay8.ebe26689.jpg";